import { render } from "./Ordersummary.vue?vue&type=template&id=684c8bae"
import script from "./Ordersummary.vue?vue&type=script&lang=js"
export * from "./Ordersummary.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__